<template>
  <a-card :bordered="false">
    <Breadcrumb routeName="MemberList" toName="添加成员" goPathName="成员列表"></Breadcrumb>
    <a-tabs default-active-key="1" type="card" style="margin-top: 20q">
      <a-tab-pane tab="单个导入" key="1">
        <SingleImportComponent></SingleImportComponent>
      </a-tab-pane>
      <a-tab-pane tab="批量导入" key="2">
        <BatchImportComponent></BatchImportComponent>
      </a-tab-pane>
      <a-tab-pane tab="前端邀请" key="3" v-if="!ownSwitch">
        <InvitationalPortComponent></InvitationalPortComponent>
      </a-tab-pane>
    </a-tabs>
  </a-card>
</template>

<script>
import Breadcrumb from '@/customComponents/Breadcrumb/Breadcrumb'
import SingleImportComponent from '../components/SingleImportComponent'
import BatchImportComponent from '../components/BatchImportComponent'
import InvitationalPortComponent from '../components/InvitationalPortComponent'
import { mapState } from 'vuex'

export default {
  name: 'CreateMember',
  components: { Breadcrumb, BatchImportComponent, SingleImportComponent, InvitationalPortComponent },
  data() {
    return {}
  },
  mounted() {
  },
  computed: {
    ...mapState({
      ownSwitch: state => state.user.ownSwitch
    })
  },
  methods: {}

}
</script>
<style scoped lang="less">
@import "../../CustomPage";
</style>